import React from 'react'

const LayersOutline = props => (
  <svg
    viewBox='0 0 18 18'
    width={props.width || '18px'}
    height={props.height || '18px'}
  >
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g
        transform='translate(-1.000000, 0.000000)'
        fill={props.color || '#C1C1C1'}
        fillRule='nonzero'
      >
        <path d='M19,8.35 C18.9765851,7.97071689 18.7402194,7.63747995 18.39,7.49 L16.24,6.57 L18.5,5.27 C18.8267322,5.08207138 19.0200371,4.7263902 19,4.35 C18.9765851,3.97071689 18.7402194,3.63747995 18.39,3.49 L10.39,0.08 C10.1407184,-0.0255801913 9.85928156,-0.0255801913 9.61,0.08 L1.61,3.49 C1.25978064,3.63747995 1.02341491,3.97071689 1,4.35 C0.979962851,4.7263902 1.17326784,5.08207138 1.5,5.27 L3.76,6.57 L1.61,7.49 C1.25978064,7.63747995 1.02341491,7.97071689 1,8.35 C0.979962851,8.7263902 1.17326784,9.08207138 1.5,9.27 L3.76,10.57 L1.61,11.49 C1.25978064,11.63748 1.02341491,11.9707169 1,12.35 C0.979962851,12.7263902 1.17326784,13.0820714 1.5,13.27 L9.5,17.87 C9.80940108,18.0486328 10.1905989,18.0486328 10.5,17.87 L18.5,13.27 C18.8267322,13.0820714 19.0200371,12.7263902 19,12.35 C18.9765851,11.9707169 18.7402194,11.63748 18.39,11.49 L16.24,10.57 L18.5,9.27 C18.8267322,9.08207138 19.0200371,8.7263902 19,8.35 L19,8.35 Z M10,2.09 L15.76,4.54 L10,7.85 L4.24,4.54 L10,2.09 Z M9.5,9.87 C9.80940108,10.0486328 10.1905989,10.0486328 10.5,9.87 L14.07,7.87 L15.76,8.59 L10,11.85 L4.24,8.54 L5.93,7.82 L9.5,9.87 Z M15.76,12.54 L10,15.85 L4.24,12.54 L5.93,11.82 L9.5,13.87 C9.80940108,14.0486328 10.1905989,14.0486328 10.5,13.87 L14.07,11.82 L15.76,12.54 Z' />
      </g>
    </g>
  </svg>
)

export default LayersOutline
